import { create } from "zustand";

const StudentsStore = create((set) => ({
  studentId: "",
  currentPage: "",
  studentBehaviorModal: false,
  setStudentId: (_id) => {
    set((prev) => ({ ...prev, studentId: _id }));
  },
  setCurrentPage: (pageName) => {
    set((prev) => ({ ...prev, currentPage: pageName }));
  },
  setStudentBehaviorModal: (pageName) => {
    set((prev) => ({
      ...prev,
      studentBehaviorModal: !prev.studentBehaviorModal,
    }));
  },
}));
export default StudentsStore;
